import { Directive, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, TemplateRef } from "@angular/core";
import { AdUploadService } from "./ad-upload.service";

export interface fileUploadEvent {
  files: FileList;
  param?: any;
  err?: any;
};

export interface UploadAPI {
  openExplore: () => void;
  clear: () => void;
}

@Directive({
  selector: '[ad-upload]',
})
export class AdUploadDirective implements OnInit {
  _name: string;
  @Input() get name(): string {
    return this._name;
  }
  set name(val: string) {
    this._name = val;
    this.updateName();
  }

  @Input() url: string;

  @Input() method: string = 'post';

  _multiple: boolean = false;
  @Input() get multiple(): boolean {
    return this._multiple;
  }
  set multiple(val: boolean) {
    this._multiple = val;
    this.updateMultiple();
  }

  _accept: string;
  @Input() get accept(): string {
    return this._accept;
  }
  set accept(val: string) {
    this._accept = val;
    this.updateAccept();
  }

  _disabled: boolean;
  @Input() get disabled(): boolean {
    return this._disabled;
  }
  set disabled(val: boolean) {
    this._disabled = val;
    this.updateDisabled();
  }

  @Input() auto: boolean;

  @Input() showSpin: boolean | 'spin';

  @Output() onSelect: EventEmitter<FileList> = new EventEmitter<FileList>();

  @Output() onUploaded: EventEmitter<fileUploadEvent> = new EventEmitter<fileUploadEvent>();

  @Output() onAPI: EventEmitter<UploadAPI> = new EventEmitter<UploadAPI>();

  _container: HTMLElement;
  _uploadInput: HTMLInputElement;
  _changeListener: Function;
  _containerClickListener: Function;

  constructor(public el: ElementRef,
    public uploadService: AdUploadService,
    public render: Renderer2) {
    this._container = this.el.nativeElement;

  }
  ngOnInit(): void {
    this.onAPI.emit(({
      openExplore: () => this.forwardFileClick(),
      clear: () => this.clear(),
    }));
  }
  clear() {
    this._uploadInput.value = '';
  }

  onFileSelected(event: any) {
    let files: FileList = event.target.files;
    if (this.uploadService.validateFiles(files)) {
      this.onSelect.emit(files);
      if (this.auto) {
        this.uploadService.uploadFiles(
          this.uploadService.transformToFormData(files, this.name),
          this.url,
          this.method,
          this.showSpin
        ).subscribe((param: any) => {
          this.onUploaded.emit({
            files,
            param
          });
        }, (err) => {
          this.onUploaded.emit({
            files,
            err
          });
        });
      }
    }
  }

  forwardFileClick() {
    this._uploadInput.click();
  }

  ngAfterViewInit() {
    const fileupload = document.createElement('input') as HTMLInputElement;
    fileupload.setAttribute('type', 'file');
    //fileupload.className='ui-helper-hidden-accessiblee';
    fileupload.style.border = '0';
    fileupload.style.position = 'absolute';
    fileupload.style.clip = 'rect(0,0,0,0)';
    fileupload.style.height = '1px';
    fileupload.style.margin = '-1px';
    fileupload.style.overflow = 'hidden';
    fileupload.style.width = '1px';
    fileupload.style.fontSize = '0';
    fileupload.style.padding = '0';
    this._container.appendChild(fileupload);
    this._uploadInput = fileupload;
    this.updateName();
    this.updateMultiple();
    this.updateAccept();
    this.updateDisabled();
    this.bindInputEvent();
  }

  ngOnDestroy() {
    this.unbindInputEvent();
    this._container.removeChild(this._uploadInput);
    this._uploadInput = null;
  }

  bindInputEvent() {
    this._changeListener = this.render.listen(this._uploadInput, 'change', this.onFileSelected.bind(this));
    this._containerClickListener = this.render.listen(this._container, 'click', this.forwardFileClick.bind(this));
  }
  unbindInputEvent() {
    this._changeListener();
    this._containerClickListener();
  }

  updateName() {
    if (this._uploadInput) {
      if (this.name && this.name.length > 0) {
        this._uploadInput.setAttribute('name', this.name);
      } else {
        this._uploadInput.removeAttribute('name');
      }
    }
  }

  updateMultiple() {
    if (this._uploadInput) {
      if (this.multiple) {
        this._uploadInput.setAttribute('multiple', '');
      } else {
        this._uploadInput.removeAttribute('multiple');
      }
    }
  }

  updateAccept() {
    if (this._uploadInput) {
      if (this.accept && this.accept.length > 0) {
        this._uploadInput.setAttribute('accept', this.accept);
      } else {
        this._uploadInput.removeAttribute('accept');
      }
    }
  }

  updateDisabled() {
    if (this._uploadInput) {
      if (this.disabled) {
        this._uploadInput.setAttribute('disabled', '');
      } else {
        this._uploadInput.removeAttribute('disabled');
      }
    }
  }
}
